import StageCardItem from './StageCardItem';

export default StageCardItem;
